'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _KendoChartMixinBase = require('./KendoChartMixinBase');

var _KendoChartMixinBase2 = _interopRequireDefault(_KendoChartMixinBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'kendo-chart',
    mixins: [_KendoChartMixinBase2.default]
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts-vue-wrapper/dist/es/KendoChartBase/index.js
// module id = 271
// module chunks = 0